import { createBeanDecorator } from 'zova';
export function Behavior(options) {
  return createBeanDecorator('behavior', 'new', true, options);
}